/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

export const useScrollToTop = <E extends HTMLElement = HTMLElement>({
  ref,
}: {
  ref: React.RefObject<E | null>;
}): void => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    const element = document.getElementById("main-scroll-container") as HTMLElement;
    element?.scroll(0, 0);

    const clearTimer = setTimeout(() => {
      ref.current?.focus();
    }, 100);

    return (): void => {
      clearTimeout(clearTimer);
    };
  }, [pathname, ref]);
};
